import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Row } from 'reactstrap';
import { InfoCard } from '../../../components';
import { useTranslation } from '../../../translations';
import { Fetcher, useFetcher } from '../../../utils';

export const Dashboard: FC<RouteComponentProps> = () => {
  const { ts } = useTranslation();

  const stats = useFetcher(async () => {
    return await api.getHotelStats();
  });

  if (!stats.success) {
    return <Fetcher result={stats} />;
  }

  return (
    <>
      <h2>{ts('common.dashboard')}</h2>
      <Row className="justify-content-center" id="dashboard">
        <InfoCard
          className="mb-10"
          heading="hotel.total_hotels"
          icon="domain"
          id="totalHotels"
          largeText
          status="info"
          text={stats.data.totalHotels ?? 'Could not load'}
        />
        <InfoCard
          className="mb-10"
          heading="hotel.total_rooms"
          icon="hotel"
          id="totalRooms"
          largeText
          status="info"
          text={stats.data.totalRooms ?? 'Could not load'}
        />
        <InfoCard
          className="mb-10"
          heading="hotel.total_reservations"
          icon="wallet"
          id="totalReservations"
          largeText
          status="info"
          text={stats.data.totalReservations ?? 'Could not load'}
        />
        <InfoCard
          className="mb-10"
          heading="hotel.total_release_groups"
          icon="groups"
          id="totalReleaseGroups"
          largeText
          status="info"
          text={stats.data.totalReleaseGroups ?? 'Could not load'}
        />
        <InfoCard
          className="mb-10"
          heading="hotel.total_release_group_entries"
          icon="note"
          id="totalReleaseGroupsEntries"
          largeText
          status="info"
          text={stats.data.totalReleaseGroupEntries ?? 'Could not load'}
        />
      </Row>
    </>
  );
};
